import { useKeepAlive } from 'crono-fe-common/hooks/crono-extension/gateway';
import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { useAuth } from 'context/auth';
import { KeepAliveContext } from './contexts';

const KeepAliveProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useAuth();
  const { call: sendKeepAlive } = useKeepAlive();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!user?.userPreferences?.extendedDebugLog) {
      return;
    }

    const executeKeepAlive = async () => {
      try {
        await sendKeepAlive(undefined);
      } catch (error) {
        console.warn('Keep-alive signal failed:', error);
      }
    };

    // Send initial keep-alive signal
    executeKeepAlive();

    // Set up interval to send keep-alive every 20 seconds
    intervalRef.current = setInterval(executeKeepAlive, 20000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [user?.userPreferences?.extendedDebugLog, sendKeepAlive]);

  return (
    <KeepAliveContext.Provider value={null}>
      {children}
    </KeepAliveContext.Provider>
  );
};

export default KeepAliveProvider;
